import React from 'react';
import { useDispatch } from 'react-redux';
import API from '../../utils/api';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Fetchs3image from '../../utils/fetchs3image';
import { useNavigate } from 'react-router-dom';
import { setLocation } from '../../redux/actions/locationActions';
import { useSelector } from 'react-redux';


const AddAPlace =() => {
    const location = useSelector((state) => state.location.location);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [place, setPlace] = useState({
        name: '',
        tagline: '',
        description: ''
      });
      const [query, setQuery] = useState('');
      const [debouncedQuery, setDebouncedQuery] = useState('');
      const [results, setResults] = useState([]);
      const handleChange = (e) => {
        const { name, value } = e.target;
      
        setPlace(prev => ({
          ...prev,
          [name]: value
        }));
      };
      const createplacerecord = async() => {
        try {
            const data = {
                name:place.name,
                tagline:place.tagline,
                description:place.description,
                latitude:location.center[1],
                longitude:location.center[0]
            }
            console.log('CREATING PLACE WITH',data)
            var res = await axios({
                method:'POST',
                url:'https://api.heytout.com/places/addplace',
                data: {
                    name:data.name,
                    tagline:data.tagline,
                    description:data.description,
                    latitude:data.latitude,
                    longitude:data.longitude
                }
    
            })
            console.log('MADE A PLACE',res)
            navigate("/editplace/" + res.data.id)
    
        } catch(error) {
            console.log('NO NO NO ',error)
        }

      }
  // 1. Debounce input by 800ms
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 800);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  // 2. Call API when debouncedQuery changes
  useEffect(() => {
    if (!debouncedQuery) {
      setResults([]);
      return;
    }

    // Example fetch — replace with your actual API call
    const fetchCities = async () => {
        console.log('running fetch city')
        try {
          const res = await axios({
            method:'POST',
            url:'https://api.heytout.com/geo/searchforlocation',
            data: {
                search:debouncedQuery
            }
          })
          const data = res;
          console.log(res.data.features)
          setResults(data.data.features);
        } catch (err) {
          console.error('Error fetching cities:', err);
        }
      };
  
      fetchCities();
    }, [debouncedQuery]);
    console.log('THE LOCAITON',location)
    return (
        <div className="tcontainer">

            <div className="trow">
                <div className="tcol">
                    <div className="tinputwrap">
                        <div className="tinputlabel">Name</div>
                        <input
                        className="tinput"
                        name="name"
                        value={place.name}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="tinputwrap">
                        <div className="tinputlabel">Tagline (short description)</div>
                        <input
                        className="tinput"
                        name="tagline"
                        value={place.tagline}
                        onChange={handleChange}
                        />
                    </div>
                    <div className="tinputwrap">
                        <div className="tinputlabel">Description</div>
                        <textarea className="ttextarea"
                            value={place.description}
                            name="description"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="tinputwrap">
                <button
                    onClick={createplacerecord}
                >create place record</button>

                    </div>

                </div>
                <div className="tcol">


                </div>
            </div>
        </div>
    )
}

export default AddAPlace;
